import moment from 'moment';

function formatDate(date) {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${month}/${day}/${year}`
}

function firstDayOfMonth() {
    const current = new Date()
    return new Date(current.getFullYear(), current.getMonth(), 1, 0, 0, 0)
}

function lastDayOfMonth() {
    const current = new Date()
    return new Date(current.getFullYear(), current.getMonth() + 1, 0, 23, 59, 59)
}

function last30Days() {
    const endDate = moment().hours(23).minutes(59).seconds(59).toDate();
    const startDate = moment().hours(0).minutes(0).seconds(0).subtract(29, 'day').toDate();
    return [startDate, endDate];
}

export {
    formatDate, 
    firstDayOfMonth, 
    lastDayOfMonth,
    last30Days,
};
